/* TK 2026-08-29: drive inline <script> v sekci — lezel v HTML presne mezi markupem
   swiperu a hero sekci a kazdy klasicky inline script parser bezpodminecne zastavi,
   zkompiluje a vykona. Presne na teto hranici konzistentne padal first paint, takze
   hero „problikaval" (trace: EvaluateScript na radku dokumentu ~5157 tesne pred FP).
   Ted external defer — parser projede markup bez zastaveni. */
document.querySelectorAll('[data-tk-cat-swiper]').forEach(function (rootEl) {
  var sid = rootEl.getAttribute('data-tk-cat-swiper');
  var scrollEl = document.getElementById('tkCatScroll-' + sid);
  var viewport = document.getElementById('tkCatViewport-' + sid);
  var leftBtn = document.getElementById('tkCatLeft-' + sid);
  var rightBtn = document.getElementById('tkCatRight-' + sid);
  if (!scrollEl || !viewport) return;

  var fadeLeft = viewport.querySelector('.tk-categories__fade--left');
  var fadeRight = viewport.querySelector('.tk-categories__fade--right');
  var track = scrollEl.querySelector('.tk-categories__track');

  /* ---- Check if track overflows (needs scrolling) ---- */
  if (track && scrollEl.scrollWidth <= scrollEl.clientWidth + 2) {
    track.classList.add('is-fitted');
  }

  /* ---- Arrow visibility & fade edges ---- */
  function updateNav() {
    var sl = scrollEl.scrollLeft;
    var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;

    if (sl > 10) {
      leftBtn.classList.add('is-visible');
      fadeLeft.classList.add('is-visible');
    } else {
      leftBtn.classList.remove('is-visible');
      fadeLeft.classList.remove('is-visible');
    }

    if (sl < maxScroll - 10) {
      rightBtn.classList.add('is-visible');
      fadeRight.classList.add('is-visible');
    } else {
      rightBtn.classList.remove('is-visible');
      fadeRight.classList.remove('is-visible');
    }
  }

  scrollEl.addEventListener('scroll', updateNav, { passive: true });

  /* ---- Arrow click — smooth scroll by visible width ---- */
  /* ⚠️ Bez inline `style.scrollBehavior` — mutace inline stylu uvnitř sekce
     spustí přes :has() recalc celé stránky (~110 ms). Šipky tu jsou VIDITELNÉ,
     takže by to platil každý klik. `behavior` se předá do scrollBy. */
  function smoothScroll(distance) {
    scrollEl.scrollBy({ left: distance, behavior: 'smooth' });
  }

  leftBtn.addEventListener('click', function() {
    smoothScroll(-scrollEl.clientWidth * 0.75);
  });

  rightBtn.addEventListener('click', function() {
    smoothScroll(scrollEl.clientWidth * 0.75);
  });

  /* ---- Drag to scroll ---- */
  var isDown = false;
  var startX = 0;
  var scrollStart = 0;
  var hasMoved = false;
  var velocity = 0;
  var lastX = 0;
  var lastTime = 0;
  var snapTimer = null;

  /* ⚠️⚠️ PRAVIDLO PRO CELÝ DRAG: nejdřív VŠECHNA čtení layoutu (scrollLeft,
     offsetWidth, getComputedStyle), teprve POTOM zápisy (class/style). Čtení
     layoutu po zápisu stylu = vynucený synchronní reflow CELÉ stránky —
     naměřeno na homepage 46–57 ms v jednom tasku (drag se při chycení „zasekl").
     Plné vysvětlení + naměřená čísla v product-list.liquid. */
  function onPointerDown(e) {
    if (e.button && e.button !== 0) return;
    isDown = true;
    hasMoved = false;
    /* ČTENÍ první (strom je čistý) */
    startX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
    scrollStart = scrollEl.scrollLeft;
    lastX = startX;
    lastTime = Date.now();
    velocity = 0;
    /* ZÁPIS až potom — snap vypnout TŘÍDOU, ne inline stylem (jinak recalc
       celé stránky přes :has(), viz poznámka u .is-snap-off v CSS). */
    /* ⚠️ Zrušit obnovení snapu z PŘEDCHOZÍHO tahu — jeho 600ms timer by
       zapnul snap doprostřed tohohle tahu (rychlé chytni-pusť-chytni). */
    clearTimeout(snapTimer);
    scrollEl.classList.add('is-snap-off');
  }

  function onPointerMove(e) {
    if (!isDown) return;
    var clientX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
    var diff = clientX - startX;
    var crossed = Math.abs(diff) > 10;

    if (crossed && e.cancelable) e.preventDefault();

    /* scrollLeft (potřebuje layout) PŘED přidáním class */
    scrollEl.scrollLeft = scrollStart - diff;

    if (crossed && !hasMoved) {
      hasMoved = true;
      scrollEl.classList.add('is-dragging');
    }

    var now = Date.now();
    var dt = now - lastTime;
    if (dt > 0) {
      velocity = (lastX - clientX) / dt;
    }
    lastX = clientX;
    lastTime = now;
  }

  function onPointerUp() {
    if (!isDown) return;
    isDown = false;

    /* dojezd podle rychlosti + dosnapování na začátek nejbližší karty
       ⚠️ Všechna čtení TADY, před `classList.remove` níž. */
    var target = null;
    if (hasMoved) {
      var card = scrollEl.querySelector('.tk-categories__card');
      if (card) {
        var gap = track ? (parseFloat(getComputedStyle(track).gap) || 12) : 12;
        var step = card.offsetWidth + gap;
        var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
        target = scrollEl.scrollLeft + velocity * 180;
        target = Math.round(target / step) * step;
        target = Math.max(0, Math.min(maxScroll, target));
      }
    }

    /* scrollTo si taky vyžádá layout → PŘED zápisem class (viz product-list). */
    if (target !== null) scrollEl.scrollTo({ left: target, behavior: 'smooth' });
    scrollEl.classList.remove('is-dragging');
    clearTimeout(snapTimer);
    snapTimer = setTimeout(function() { scrollEl.classList.remove('is-snap-off'); }, 600);
  }

  // Mouse drag jen na desktopu (touch necháme browser handle nativně — smooth jako aktin.cz)
  scrollEl.addEventListener('mousedown', onPointerDown);
  window.addEventListener('mousemove', onPointerMove);
  window.addEventListener('mouseup', onPointerUp);

  scrollEl.addEventListener('dragstart', function(e) { e.preventDefault(); });

  scrollEl.addEventListener('click', function(e) {
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
    }
    hasMoved = false;
  }, true);

  /* ---- Reveal animation ODSTRANĚNA (JS 2026-07-27, i CSS 2026-08-07) ----
     Detaily a naměřená čísla viz komentář u `.tk-categories__card` ve stylu.
     Zůstává jen updateNav, které se dřív volalo až po doběhnutí staggeru. */
  updateNav();
  /* Ještě jednou po doběhnutí layoutu (lazy obrázky mění šířky). */
  setTimeout(updateNav, 500);
});
